import { FC, PropsWithChildren } from 'react';
import { getProcess } from '@belong/configs/next/config';
import { Dictionary } from '@belong/contentful';
import { IDictionary } from '@belong/types';

const EVN_KEYS = ['NEXT_PUBLIC_CONTENT_UNSUBSCRIBE_URL'];

const { env } = getProcess();

const filteredContentEnvVars = EVN_KEYS.reduce(
  (acc, key) => {
    acc[key] = env[key];
    return acc;
  },
  {} as Record<string, string>
);

/**
 *
 * Read CONTENTFUL env vars for future use in RichText
 *
 */
interface IRichTextDictionaryProps extends PropsWithChildren {
  dictionary?: IDictionary;
}

export const RichTextDictionary: FC<IRichTextDictionaryProps> = ({ children, dictionary }) => {
  return <Dictionary value={{ ...filteredContentEnvVars, ...dictionary }}>{children}</Dictionary>;
};
